var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 240",
    d: "M14.074 7.407a8.353 8.353 0 003.7.833A8.582 8.582 0 0026.389 0h-8.148a.091.091 0 00-.093.093 9.449 9.449 0 01-4.074 7.314z",
    fill: "#00aa89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M12.315 9.907a8.353 8.353 0 00-3.7-.833A8.582 8.582 0 000 17.315h8.148a10.3 10.3 0 014.167-7.408z",
    fill: "#00aa89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M17.778 9.074a9.84 9.84 0 01-4.63-1.2l-.093-.093A10.743 10.743 0 0111.112 6.3 9.4 9.4 0 018.334 0H.093v13.8a9.577 9.577 0 018.7-5.556 9.84 9.84 0 014.63 1.2l.093.093a10.743 10.743 0 011.944 1.481 9.4 9.4 0 012.778 6.3h8.241v-13.8a9.68 9.68 0 01-8.701 5.556z",
    fill: "#002ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 243",
    d: "M33.981 7.13h5.741V1.852h2.685v13.519h-2.685V9.352h-5.741v6.019h-2.685V1.852h2.685z",
    fill: "#1d1976"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 244",
    d: "M53.333 12.962a4.95 4.95 0 01-7.685 1.574 4.284 4.284 0 01-1.389-3.425 4.749 4.749 0 011.3-3.43 4.405 4.405 0 013.333-1.2 4.133 4.133 0 013.426 1.481 5.216 5.216 0 011.019 3.426v.185h-6.578a2.562 2.562 0 00.463 1.481 2.128 2.128 0 001.759.833 2.2 2.2 0 002.037-1.2zm-2.315-3.148a2.076 2.076 0 00-2.13-1.759 1.987 1.987 0 00-2.037 1.759z",
    fill: "#1d1976"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 245",
    d: "M55.278 6.667h2.5v1.3a2.789 2.789 0 011.107-1.208 2.349 2.349 0 011.481-.37 2.858 2.858 0 011.019.185l-.37 2.315a2.316 2.316 0 00-1.2-.37 1.964 1.964 0 00-1.667.741 2.911 2.911 0 00-.463 1.944v4.259h-2.5v-8.8z",
    fill: "#1d1976"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 246",
    d: "M70.649 7.59a4.892 4.892 0 011.481 3.429 4.723 4.723 0 01-1.481 3.426 5.744 5.744 0 01-7.037 0 4.892 4.892 0 01-1.482-3.426 4.564 4.564 0 011.481-3.429 5.135 5.135 0 013.519-1.2 4.511 4.511 0 013.519 1.2zm-1.111 3.426a2.433 2.433 0 00-2.5-2.5 2.5 2.5 0 000 5 2.433 2.433 0 002.499-2.497z",
    fill: "#1d1976"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M75.185 1.389a1.481 1.481 0 11-1.481 1.481 1.463 1.463 0 011.481-1.481zm1.2 5.278v8.8h-2.5v-8.8z",
    fill: "#1d1976"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 248",
    d: "M81.296 8.704v6.667h-2.5V8.704h-.926V6.578h.926V4.167a3.918 3.918 0 011.2-3.148 3.3 3.3 0 012.13-.741 3.092 3.092 0 011.389.278v2.222a1.617 1.617 0 00-1.111-.37 1.025 1.025 0 00-.926.463 3.246 3.246 0 00-.278 1.481v2.126h2.315v2.13h-2.222z",
    fill: "#1d1976"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 249",
    d: "M88.426 14.074l-4.167-7.5h2.87l2.685 5 2.407-5h2.778L87.869 20h-2.778z",
    fill: "#1d1976"
  })));
}

export default SvgLogo;